// Our stored files (/api/files/..., /uploads/...) under the site's OWN address on the live domains.
// Every domain proxies /api/* to the backend (vercel.json), so tech-n-ai-talks.com/api/files/x.webp works and
// no page shows a reader, or Google, the parent's api.allmarketingmixed.com. Preview/admin keeps the backend URL.
import siteConfig from '@/config/siteConfig';

const API = process.env.REACT_APP_BACKEND_URL || '';
const BACKEND = /^https?:\/\/api\.allmarketingmixed\.com(?=\/(api|uploads)\/)/;
// Local per-site hosts (tech-n-ai-talks.localhost:3001) have no /api proxy, so they keep the backend URL.
const ON_LIVE_DOMAIN = siteConfig.isMultiDomain && typeof window !== 'undefined'
  && !/(^|\.)localhost$|^127\.0\.0\.1$/.test(window.location.hostname);

export function assetUrl(url, { absolute = false } = {}) {
  if (!url || typeof url !== 'string' || url.startsWith('data:')) return url;
  let u = url.replace(BACKEND, '');
  if (API && u.startsWith(API + '/')) u = u.slice(API.length);
  if (!(u.startsWith('/api/') || u.startsWith('/uploads/'))) return u;   // someone else's image, untouched
  if (!ON_LIVE_DOMAIN) return `${API}${u}`;
  return absolute && typeof window !== 'undefined' ? `${window.location.origin}${u}` : u;
}
